import React, { useState } from 'react';
import Avatar from 'components/common/Avatar';
import Flex  from 'components/common/Flex';
import SoftBadge from 'components/common/SoftBadge';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { parseDate } from 'helpers/utils';
import {deleteAlumnoById, updateCurso, updateReinscription, updateSeguro, updateStatus, updateTypeCuota } from 'data/apiConection.js/dataAlumnos';
import { updateCupoMaximoCursoById } from 'data/apiConection.js/dataCursos';
import { FiEdit } from 'react-icons/fi';
import { updateCuotas } from 'data/apiConection.js/dataCuotas';
//import { updateCuotas } from 'data/apiConection.js/dataCuotas';


const PrioritySelect = ({ title, color, data, className, style }) => {
  return (
    <div
      style={style}
      className={classNames('d-flex align-items-center gap-2', className)}
    >
      <div style={{ '--falcon-circle-progress-bar': data }}>
        <svg
          className="circle-progress-svg"
          width="26"
          height="26"
          viewBox="0 0 120 120"
        >
          <circle
            className="progress-bar-rail"
            cx="60"
            cy="60"
            r="54"
            fill="none"
            strokeLinecap="round"
            strokeWidth="12"
          ></circle>
          <circle
            className="progress-bar-top"
            cx="60"
            cy="60"
            r="54"
            fill="none"
            strokeLinecap="round"
            stroke={color}
            strokeWidth="12"
          ></circle>
        </svg>
      </div>
      <h6 className="mb-0 text-700">{title}</h6>
    </div>
  );
};

PrioritySelect.propTypes = {
  title: PropTypes.string,
  color: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
  data: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

const AgentSelect = ({ agent, className, style }) => {
  return (
    <Form.Select
      style={style}
      className={className}
      size="sm"
      defaultValue={agent}
    >
      {['Select Agent', 'Anindya', 'Nowrin', 'Khalid'].map(item => (
        <option key={item}>{item}</option>
      ))}
    </Form.Select>
  );
};

AgentSelect.propTypes = {
  agent: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object
};
export const columns = [
  {
    accessor: row => `${row.firstName} ${row.lastName}`,
    Header: 'Alumno',
    headerProps: { className: 'ps-2', style: { height: '46px' } },
    cellProps: {
      className: 'py-2 white-space-nowrap pe-3 pe-xxl-4 ps-2'
    },
    Cell: rowData => {
      const { firstName , lastName , id } = rowData.row.original;
      return (
        <Flex alignItems="center" className="position-relative py-1">
          <h6 className="mb-0">
            <Link
              to={"/support-desk/contact-details/"+id}
              className="stretched-link text-900"
            >
              {firstName+" "+lastName}
            </Link>
          </h6>
        </Flex>
      );
    }
  },
  {
    accessor: 'dni',
    Header: 'DNI',
    headerProps: { style: { minWidth: '14.625rem' } },
    cellProps: {
      className: 'py-2 pe-4'
    },
    Cell: rowData => {
      const { dni } = rowData.row.original;
      return dni;
    }
  },
  {
    accessor: 'gender',
    Header: 'Sexo',
    headerProps: { style: { minWidth: '14.625rem' } },
    cellProps: {
      className: 'py-2 pe-4'
    },
    Cell: rowData => {
      const { gender } = rowData.row.original;
      return gender;
    }
  },
  {
    accessor: 'birthDate',
    Header: 'Nacimiento',
    headerProps: { style: { minWidth: '14.625rem' } },
    cellProps: {
      className: 'py-2 pe-4'
    },
    Cell: rowData => {
      const { birthDate } = rowData.row.original;
      return parseDate(birthDate);
    }
  },
  {
    accessor: 'phone',
    Header: 'Telefono',
    headerProps: { style: { minWidth: '14.625rem' } },
    cellProps: {
      className: 'py-2 pe-4'
    },
    Cell: rowData => {
      const { phone } = rowData.row.original;
      return phone;
    },
  } ,
  {
    accessor: 'status',
    Header: 'Status',
    cellProps: {
      className: 'fs-0 pe-4'
    },
    Cell: rowData => {
      const { status, id } = rowData.row.original;
      return (
          <button
              className={`btn btn-${status === 'deuda' ? 'danger' : 'primary'} btn-sm`}
              style={{
                  padding: '5px 10px',
                  fontSize: '0.9rem',
                  borderRadius: '5px',
                  opacity: 0.85, // Opacidad inicial
                  transition: 'opacity 0.2s', // Suavidad en el hover
              }}
              onMouseOver={(e) => e.currentTarget.style.opacity = 1} // Aumenta opacidad al pasar el cursor
              onMouseOut={(e) => e.currentTarget.style.opacity = 0.75} // Restaurar opacidad
              onClick={() => {
                  status === 'deuda'
                      ? updateStatus(id, { status: 'apto' })
                      : updateStatus(id, { status: 'deuda' });
              }}
          >
              {status === 'deuda' ? 'Deuda' : 'Apto'}
          </button>
      );
  }
  },
  {
    accessor: 'inscripcion',
    Header: 'Inscripto',
    cellProps: {
      className: 'fs-0 pe-4'
    },
    Cell: rowData => {
      const { inscripcion, id } = rowData.row.original;
      return (
          <button
              className={`btn btn-${inscripcion === 'reinscribir' ? 'warning' : 'success'} btn-sm`}
              style={{
                  padding: '5px 10px',
                  fontSize: '0.9rem',
                  borderRadius: '5px',
                  opacity: 0.85, // Ajuste de opacidad
                  transition: 'opacity 0.2s', // Suavidad en el hover
              }}
              onMouseOver={(e) => e.currentTarget.style.opacity = 1} // Efecto hover
              onMouseOut={(e) => e.currentTarget.style.opacity = 0.85} // Restaurar opacidad
              onClick={() => {
                  inscripcion === 'reinscribir'
                      ? updateReinscription(id, { inscripcion: 'inscripto' })
                      : updateReinscription(id, { inscripcion: 'reinscribir' });
              }}
          >
              {inscripcion === 'reinscribir' ? 'Reinscribir' : 'Inscribir'}
          </button>
      );
  }
   
  }
];
export const columnsAlumnos = ( flagUpdate , setFlagUpdate , cursos ) => {
  const columns = [
    {
      accessor: row => `${row.firstName} ${row.lastName}`,
      Header: 'Alumno',
      headerProps: { className: 'ps-2', style: { height: '46px' } },
      cellProps: {
        className: 'py-2 white-space-nowrap pe-3 pe-xxl-4 ps-2'
      },
      Cell: rowData => {
        const { firstName , lastName , id } = rowData.row.original;
        return (
          <Flex alignItems="center" className="position-relative py-1">
            <h6 className="mb-0">
              <Link
                to={"/support-desk/contact-details/"+id}
                className="stretched-link text-900"
              >
                {firstName+" "+lastName}
              </Link>
            </h6>
          </Flex>
        );
      }
    },
    {
      accessor: 'dni',
      Header: 'DNI',
      headerProps: { style: { width: '100px'} },
      cellProps: {
        className: 'py-2 pe-4',
        style: { height: '46px', width: '100px' }
      },
      Cell: rowData => {
        const { dni } = rowData.row.original;
        return dni;
      }
    }/*,
    {
      accessor: 'gender',
      Header: 'Sexo',
      headerProps: { style: { minWidth: '14.625rem' } },
      cellProps: {
        className: 'py-2 pe-4'
      },
      Cell: rowData => {
        const { gender } = rowData.row.original;
        return gender;
      }
    },
    {
      accessor: 'birthDate',
      Header: 'Nacimiento',
      headerProps: { style: { minWidth: '14.625rem' } },
      cellProps: {
        className: 'py-2 pe-4'
      },
      Cell: rowData => {
        const { birthDate } = rowData.row.original;
        return parseDate(birthDate);
      }
    },
    {
      accessor: 'phone',
      Header: 'Telefono',
      headerProps: { style: { minWidth: '14.625rem' } },
      cellProps: {
        className: 'py-2 pe-4'
      },
      Cell: rowData => {
        const { phone } = rowData.row.original;
        return phone;
      },
    } ,
    {
      accessor: 'status',
      Header: 'Status',
      cellProps: {
        className: 'fs-0 pe-4'
      },
      Cell: rowData => {
        const { status, id } = rowData.row.original;
        return (
            <button
                className={`btn btn-${status === 'deuda' ? 'danger' : 'primary'} btn-sm`}
                style={{
                    padding: '5px 10px',
                    fontSize: '0.9rem',
                    borderRadius: '5px',
                    opacity: 0.85, // Opacidad inicial
                    transition: 'opacity 0.2s', // Suavidad en el hover
                }}
                onMouseOver={(e) => e.currentTarget.style.opacity = 1} // Aumenta opacidad al pasar el cursor
                onMouseOut={(e) => e.currentTarget.style.opacity = 0.75} // Restaurar opacidad
                onClick={() => {
                    status === 'deuda'
                        ? updateStatus(id, { status: 'apto' })
                        : updateStatus(id, { status: 'deuda' });
                    setFlagUpdate(!flagUpdate);
                }}
            >
                {status === 'deuda' ? 'Deuda' : 'Apto'}
            </button>
        );
    }
    },
    {
      accessor: 'inscripcion',
      Header: 'Inscripto',
      cellProps: {
        className: 'fs-0 pe-4'
      },
      Cell: rowData => {
        const { inscripcion, id } = rowData.row.original;
        return (
            <button
                className={`btn btn-${inscripcion === 'reinscribir' ? 'warning' : 'success'} btn-sm`}
                style={{
                    padding: '5px 10px',
                    fontSize: '0.9rem',
                    borderRadius: '5px',
                    opacity: 0.85, // Ajuste de opacidad
                    transition: 'opacity 0.2s', // Suavidad en el hover
                }}
                onMouseOver={(e) => e.currentTarget.style.opacity = 1} // Efecto hover
                onMouseOut={(e) => e.currentTarget.style.opacity = 0.85} // Restaurar opacidad
                onClick={() => {
                    inscripcion === 'reinscribir'
                        ? updateReinscription(id, { inscripcion: 'inscripto' })
                        : updateReinscription(id, { inscripcion: 'reinscribir' });
                        setFlagUpdate(!flagUpdate);
                }}
            >
                {inscripcion === 'reinscribir' ? 'Reinscribir' : 'Inscribir'}
            </button>
        );
    },
    }*/,
    {
      accessor: 'curso_id',
      Header: 'Curso',
      headerProps: { style: { minWidth: '14.625rem' } },
      cellProps: {
        className: 'py-2 pe-4'
      },
      Cell: rowData => {
        const { curso_id } = rowData.row.original;
        const dataCurso = cursos.find(curso => curso.id === curso_id);
        console.log(curso_id);
        return (
          <div value={dataCurso ? dataCurso.curso_id : null}>
              {dataCurso ? dataCurso.curso : 'Curso no encontrado'}
          </div>
      );
      }
      
    }
    , {
      accessor: 'promediop_escrito',
      Header: 'P. Escrito',
      headerProps: { width: '80px'},
      cellProps: {
        className: 'py-2 pe-4'
      },
      Cell: rowData => {
        const { promedio_escrito } = rowData.row.original;
        return promedio_escrito;
      }
    },
    {
      accessor: 'promedio_oral',
      Header: 'P. Oral',
      headerProps: { width: '80px'},
      cellProps: {
        className: 'py-2 pe-4'
      },
      Cell: rowData => {
        const { promedio_oral } = rowData.row.original;
        return promedio_oral;
      }
    },
    {
      accessor: 'promedio',
      Header: 'P. General',
      headerProps: { style: { minWidth: '14.625rem' } },
      cellProps: {
        className: 'py-2 pe-4'
      },
      Cell: rowData => {
        const { promedio } = rowData.row.original;
        return promedio;
      }
    }/*
    {
      accessor: 'curso',
      Header: 'Curso',
      headerProps: { style: { minWidth: '14.625rem' } },
      cellProps: {
        className: 'py-2 pe-4'
      },
      Cell: rowData => {
        const { curso_id , id } = rowData.row.original;
        
        return (
          <select onChange={(e)=> {
            updateCurso(id, { curso_id: e.target.value  });
            setFlagUpdate(!flagUpdate);
          }}
           defaultValue={curso_id} style={{ width: '100px', height: '30px' }}>
            {cursos.map(curso => (
              <option key={curso.id} value={curso.id}>
                {curso.curso}
              </option>
            ))}
          </select>
        );
      },
      
    } */
  ];
  return columns;
}
export const columnsAlumnosExamenes = ( flagUpdate , setFlagUpdate , cursos ) => {
  const columns = [
    {
   //   accessor: row => `${row.firstName} ${row.lastName}`,
      Header: 'Alumno',
      headerProps: { style: { Width: '200px' } },
      cellProps: {
        className: 'py-2 white-space-nowrap pe-3 pe-xxl-4 ps-2'
      },
      Cell: rowData => {
        const { firstName , lastName , id } = rowData.row.original;
        return (
          <Flex alignItems="center" className="position-relative py-1">
            <h6 className="mb-0">
              <Link
                to={"/support-desk/contact-details/"+id}
                className="stretched-link text-900"
              >
                {firstName+" "+lastName}
              </Link>
            </h6>
          </Flex>
        );
      }
    },
    {
     // accessor: row => `${row.dni}`,
      Header: 'DNI',
      headerProps: { style: { Width: '100px' } },
      cellProps: {
        className: 'py-2 pe-4'
      },
      Cell: rowData => {
        const { dni } = rowData.row.original;
        return dni;
      }
    } , {
      accessor: row => `${row.curso_id}`,
      Header: 'Curso',
      headerProps: { style: { minWidth: '14.625rem' } },
      cellProps: {
        className: 'py-2 pe-4'
      },
      Cell: rowData => {
        const { curso_id } = rowData.row.original;
        const dataCurso = cursos.find(curso => curso.id === curso_id);
        console.log(curso_id);
        return (
          <div value={dataCurso ? dataCurso.curso_id : null}>
              {dataCurso ? dataCurso.curso : 'Curso no encontrado'}
          </div>
      );
      }
      
    },{
      accessor: row => `${row.curso_id}`,
      Header: 'Asignar Curso',
      headerProps: { style: { Width: '300px' } },
      cellProps: {
        className: 'py-2 pe-4'
      },
      Cell: rowData => {
        const { curso_id , id } = rowData.row.original;
        
        return (
          <select onChange={(e)=> {
            updateCurso(id, { curso_id: e.target.value  });
            setFlagUpdate(!flagUpdate);
          }}
           defaultValue={curso_id} style={{ width: '100px', height: '30px' }}>
            {cursos.map(curso => (
              <option key={curso.id} value={curso.id}>
                {curso.curso}
              </option>
            ))}
          </select>
        );
      },
      
    } /*,
    {
      accessor: 'gender',
      Header: 'Sexo',
      headerProps: { style: { minWidth: '14.625rem' } },
      cellProps: {
        className: 'py-2 pe-4'
      },
      Cell: rowData => {
        const { gender } = rowData.row.original;
        return gender;
      }
    },
    {
      accessor: 'birthDate',
      Header: 'Nacimiento',
      headerProps: { style: { minWidth: '14.625rem' } },
      cellProps: {
        className: 'py-2 pe-4'
      },
      Cell: rowData => {
        const { birthDate } = rowData.row.original;
        return parseDate(birthDate);
      }
    },
    {
      accessor: 'phone',
      Header: 'Telefono',
      headerProps: { style: { minWidth: '14.625rem' } },
      cellProps: {
        className: 'py-2 pe-4'
      },
      Cell: rowData => {
        const { phone } = rowData.row.original;
        return phone;
      },
    } */,
    {
      accessor: 'status',
      Header: 'Status',
      cellProps: {
        className: 'fs-0 pe-4'
      },
      Cell: rowData => {
        const { status, id } = rowData.row.original;

    // Estado local para manejar el estado temporal del botón
    const [localStatus, setLocalStatus] = useState(status);

    return (
        <button
            className={`btn btn-${localStatus === 'deuda' ? 'danger' : 'primary'} btn-sm`}
            style={{
                padding: '5px 10px',
                fontSize: '0.9rem',
                borderRadius: '5px',
                opacity: 0.85, // Opacidad inicial
                transition: 'opacity 0.2s', // Suavidad en el hover
            }}
            onMouseOver={(e) => e.currentTarget.style.opacity = 1} // Aumenta opacidad al pasar el cursor
            onMouseOut={(e) => e.currentTarget.style.opacity = 0.75} // Restaurar opacidad
            onClick={() => {
                // Cambiar el estado local y actualizar el estado global
                const newStatus = localStatus === 'deuda' ? 'apto' : 'deuda';
                setLocalStatus(newStatus); // Actualiza el estado local
                updateStatus(id, { status: newStatus }); // Actualiza el estado global
            }}
        >
            {localStatus === 'deuda' ? 'Deuda' : 'Apto'} {/* Mostrar el texto correcto */}
        </button>
    );
    }
    },
    {
      accessor: 'inscripcion',
      Header: 'Inscripto',
      cellProps: {
        className: 'fs-0 pe-4'
      },
      Cell: rowData => {
        const { inscripcion, id } = rowData.row.original;
        return (
            <button
                className={`btn btn-${inscripcion === 'reinscribir' ? 'warning' : 'success'} btn-sm`}
                style={{
                    padding: '5px 10px',
                    fontSize: '0.9rem',
                    borderRadius: '5px',
                    opacity: 0.85, // Ajuste de opacidad
                    transition: 'opacity 0.2s', // Suavidad en el hover
                }}
                onMouseOver={(e) => e.currentTarget.style.opacity = 1} // Efecto hover
                onMouseOut={(e) => e.currentTarget.style.opacity = 0.85} // Restaurar opacidad
                onClick={() => {
                    inscripcion === 'reinscribir'
                        ? updateReinscription(id, { inscripcion: 'inscripto' })
                        : updateReinscription(id, { inscripcion: 'reinscribir' });
                        setFlagUpdate(!flagUpdate);
                }}
            >
                {inscripcion === 'reinscribir' ? 'Reinscribir' : 'Inscripto'}
            </button>
        );
    },
    },
  
    /*
    {
      accessor: 'curso',
      Header: 'Curso',
      headerProps: { style: { minWidth: '14.625rem' } },
      cellProps: {
        className: 'py-2 pe-4'
      },
      Cell: rowData => {
        const { curso_id , id } = rowData.row.original;
        
        return (
          <select onChange={(e)=> {
            updateCurso(id, { curso_id: e.target.value  });
            setFlagUpdate(!flagUpdate);
          }}
           defaultValue={curso_id} style={{ width: '100px', height: '30px' }}>
            {cursos.map(curso => (
              <option key={curso.id} value={curso.id}>
                {curso.curso}
              </option>
            ))}
          </select>
        );
      },
      
    } */
  ];
  return columns;
}
export const columnsAlumnos2025 = ( flagUpdate , setFlagUpdate , cursos ) => {
  const [ localSeguro , setLocalSeguro ] = useState('');
  const deleteAlumno = async (id) => {
    if (window.confirm("¿Estás seguro de que deseas eliminar este alumno?")) {
      try {
        // Llamada a la API para eliminar el alumno
        await deleteAlumnoById(id);
        // Actualiza el estado para reflejar los cambios
        setFlagUpdate(!flagUpdate);
      } catch (error) {
        console.error("Error al eliminar el alumno:", error);
      }
    }
  };
  const updateSeguroById = async (id) => {
    if (window.confirm("¿Estás seguro de que deseas actualizar el estado del seguro?")) {
      try {
        // Determinar el nuevo valor del seguro
        const newSeguro = localSeguro === 'baja' ? 'alta' : 'baja';
        
        // Actualizar el estado local
        setLocalSeguro(newSeguro);
        
        // Llamar a la API para actualizar en el servidor
        await updateSeguro(id, '2025', newSeguro);
        
        // Actualizar la tabla
        setFlagUpdate(!flagUpdate);
      } catch (error) {
        console.error('Error updating seguro by id', error);
      }
    }
  }
  const columns = [
    {
      accessor: row => `${row.firstName} ${row.lastName}`,
      Header: 'Alumno',
      headerProps: { style: { Width: '200px' } },
      cellProps: {
        className: 'py-2 white-space-nowrap pe-3 pe-xxl-4 ps-2'
      },
      Cell: rowData => {
        const { firstName , lastName , id } = rowData.row.original;
        return (
          <Flex alignItems="center" className="position-relative py-1">
            <h6 className="mb-0">
              <Link
                to={"/support-desk/contact-details/"+id}
                className="stretched-link text-900"
              >
                {firstName+" "+lastName}
              </Link>
            </h6>
          </Flex>
        );
      }
    },
    {
      Header: 'DNI',
      headerProps: { style: { Width: '100px' } },
      cellProps: {
        className: 'py-2 pe-4'
      },
      Cell: rowData => {
        const { dni } = rowData.row.original;
        return dni;
      }
    } ,
    {
      Header: 'Email',
      headerProps: { style: { Width: '100px' } },
      cellProps: {
        className: 'py-2 pe-4'
      },
      Cell: rowData => {
        const { email } = rowData.row.original;
        return email;
      }
    } , {
      Header: 'Curso',
      headerProps: { style: { minWidth: '14.625rem' } },
      cellProps: {
        className: 'py-2 pe-4'
      },
      Cell: rowData => {
        const { curso_id } = rowData.row.original;
        const { nivel, horario } = rowData.row.original;
        const dataCurso = curso_id ? cursos.find(curso => curso.id === curso_id) : null;
        if (dataCurso) {
          return (
            <div>
              {dataCurso.nivel + ' ' + dataCurso.horario}
            </div>
          );
        } else {
          return (
            <div>
              {nivel + ' ' + horario}
            </div>
          );
        }
      }
      
    },{
      accessor: row => `${row.curso_id}`,
      Header: 'Asignar Curso',
      headerProps: { style: { Width: '300px' } },
      cellProps: {
        className: 'py-2 pe-4'
      },
      Cell: rowData => {
        const { curso_id , id , nivel , horario } = rowData.row.original;
        
        return (
          <select 
            onChange={(e)=> {
              const body = { curso_id: e.target.value,curso_id_old:curso_id }
              updateCurso(id,body);
              setFlagUpdate(!flagUpdate);
              }}
             defaultValue={curso_id} style={{ width: '100px', height: '30px' }}>
              {curso_id?<option>{nivel+' '+horario}</option>:<option>{"Seleccione curso"}</option>}
            {cursos.map(curso => (
              <option key={curso.id} value={curso.id}>
                {curso.nivel+' '+curso.horario}
              </option>
            ))}
          </select>
        );
      },
      
    },
    {
      accessor: row=> row.seguro,
      Header: 'Seguro',
      headerProps: { 
        style: { 
          whiteSpace: 'nowrap',
        } 
      },
      cellProps: {
        className: 'py-2 pe-4',
        style: {
          whiteSpace: 'nowrap',
        }
      },
      Cell: rowData => {
        const { seguro, id } = rowData.row.original;
        
        return (
          <div 
            onClick={() => {
              setLocalSeguro(seguro); // Establecemos el seguro actual antes de actualizar
              updateSeguroById(id);
            }}
            style={{ cursor: 'pointer' }} // Cambia el cursor para indicar que es clickeable
          >
            <SoftBadge bg={seguro === 'baja' ? 'warning' : 'success'}>
              {seguro}
            </SoftBadge>
          </div>
        );
      }
    },
    {
      Header: 'Acciones',
      cellProps: {
        className: 'py-2 pe-4'
      },
      Cell: rowData => {
        const { id } = rowData.row.original;
        return (
          <> <Flex>                <Button
                  size="sm"
                  variant="danger"
                  onClick={() => deleteAlumno(id)}
                  style={{ marginRight: '8px' }}
                >
                <FontAwesomeIcon icon="trash-alt" />
                </Button>
   
                <Link
                  to={"/alumnos/nuevo/"+id}
                  size="sm"
                  style={{ marginRight: '8px' }}
                  className='btn bg-primary'
                >
                <FontAwesomeIcon icon="edit" />
                </Link>  
                <Link
                  to={"/estados-cuentas/"+id/*"/alumnos/cuotas/nuevo/"+id*/}
                  size="sm"
                  variant="warning"
                  style={{ marginRight: '8px' }}
                  className='btn bg-warning'
                >
                <FontAwesomeIcon icon="plus" />
                </Link> 
             </Flex>
          </>
        );
      },
    }
    
  ];
  return columns;
  /* 
  
    {
      accessor: 'status',
      Header: 'Status',
      cellProps: {
        className: 'fs-0 pe-4'
      },
      Cell: rowData => {
        const { status, id } = rowData.row.original;
        const [localStatus, setLocalStatus] = useState(status);

    return (
        <button
            className={`btn btn-${localStatus === 'deuda' ? 'danger' : 'primary'} btn-sm`}
            style={{
                padding: '5px 10px',
                fontSize: '0.9rem',
                borderRadius: '5px',
                opacity: 0.85, // Opacidad inicial
                transition: 'opacity 0.2s', // Suavidad en el hover
            }}
            onMouseOver={(e) => e.currentTarget.style.opacity = 1} // Aumenta opacidad al pasar el cursor
            onMouseOut={(e) => e.currentTarget.style.opacity = 0.75} // Restaurar opacidad
            onClick={() => {
                // Cambiar el estado local y actualizar el estado global
                const newStatus = localStatus === 'deuda' ? 'apto' : 'deuda';
                setLocalStatus(newStatus); // Actualiza el estado local
                updateStatus(id, { status: newStatus }); // Actualiza el estado global
            }}
        >
            {localStatus === 'deuda' ? 'Deuda' : 'Apto'} Mostrar el texto correcto 
           // </button>
          //);
         // }
          //}
   */
}
 /*
    {
      accessor: 'inscripcion',
      Header: 'Inscripto',
      cellProps: {
        className: 'fs-0 pe-4'
      },
      Cell: rowData => {
        const { inscripcion, id } = rowData.row.original;
        return (
            <button
                className={`btn btn-${inscripcion === 'reinscribir' ? 'warning' : 'success'} btn-sm`}
                style={{
                    padding: '5px 10px',
                    fontSize: '0.9rem',
                    borderRadius: '5px',
                    opacity: 0.85, // Ajuste de opacidad
                    transition: 'opacity 0.2s', // Suavidad en el hover
                }}
                onMouseOver={(e) => e.currentTarget.style.opacity = 1} // Efecto hover
                onMouseOut={(e) => e.currentTarget.style.opacity = 0.85} // Restaurar opacidad
                onClick={() => {
                    inscripcion === 'reinscribir'
                        ? updateReinscription(id, { inscripcion: 'inscripto' })
                        : updateReinscription(id, { inscripcion: 'reinscribir' });
                        setFlagUpdate(!flagUpdate);
                }}
            >
                {inscripcion === 'reinscribir' ? 'Reinscribir' : 'Inscripto'}
            </button>
        );
    },
    }*/
  
    /*
    {
      accessor: 'curso',
      Header: 'Curso',
      headerProps: { style: { minWidth: '14.625rem' } },
      cellProps: {
        className: 'py-2 pe-4'
      },
      Cell: rowData => {
        const { curso_id , id } = rowData.row.original;
        
        return (
          <select onChange={(e)=> {
            updateCurso(id, { curso_id: e.target.value  });
            setFlagUpdate(!flagUpdate);
          }}
           defaultValue={curso_id} style={{ width: '100px', height: '30px' }}>
            {cursos.map(curso => (
              <option key={curso.id} value={curso.id}>
                {curso.curso}
              </option>
            ))}
          </select>
        );
      },
      
    } */
export const columnsCurso = [
  { accessor: row => `${row.nivel}`,
    Header: 'nivel',
    headerProps: { style: { minWidth: '14.625rem' } },
    cellProps: {
      className: 'py-2 pe-4'
    },
    Cell: rowData => {
      const { nivel } = rowData.row.original;
      return nivel;
    }
  },
  {
    accessor: 'horario',
    Header: 'horario',
    headerProps: { style: { minWidth: '14.625rem' } },
    cellProps: {
      className: 'py-2 pe-4'
    },
    Cell: rowData => {
      const { horario } = rowData.row.original;
      return horario;
    }
  }
  ,  {
    accessor: 'Alumnos',
    Header: 'Alumnos',
    headerProps: { style: { minWidth: '14.625rem' } },
    cellProps: {
      className: 'py-2 pe-4'
    },
    Cell: rowData => {
      const { cupo } = rowData.row.original;
      return cupo;
    }
  },
  {
    accessor: 'cupo',
    Header: 'Cupo',
    headerProps: { style: { minWidth: '14.625rem' } },
    cellProps: {
      className: 'py-2 pe-4'
    },
    Cell: rowData => {
      const { cupo_maximo, id } = rowData.row.original;
      const [value, setValue] = React.useState(cupo_maximo);  // Usa React.useState correctamente
  
      const handleClick = async () => {
        await updateCupoMaximoCursoById(id, value);
      };
  
      return (
        <div className='row align-items-center g-2'>
        <div className='col'>
          <input
            type="number"
            value={value}
            onChange={(e) => setValue(e.target.value)}
            className="form-control"
            style={{ width: '100%' }}
          />
        </div>
        <div className='col-auto'>
          <button
            onClick={handleClick}
            className="btn btn-primary"
          >
            Actualizar
          </button>
        </div>
      </div>
      );
    }
  }
  
];
export const columnsProfesores = [
  {
    accessor: row => `${row.firstName} ${row.lastName}`,
    Header: 'nombre',
    headerProps: { className: 'ps-2', style: { height: '46px' } },
    cellProps: {
      className: 'py-2 white-space-nowrap pe-3 pe-xxl-4 ps-2'
    },
    Cell: rowData => {
      const { firstName , lastName } = rowData.row.original;
      return (
        <Flex alignItems="center" className="position-relative py-1">
          <h6 className="mb-0">
              {firstName+" "+lastName}
          </h6>
        </Flex>
      );
    }
  },
  {
    accessor: 'dni',
    Header: 'DNI',
    headerProps: { style: { minWidth: '14.625rem' } },
    cellProps: {
      className: 'py-2 pe-4'
    },
    Cell: rowData => {
      const { dni } = rowData.row.original;
      return dni;
    }
  },
  {
    accessor: 'birthDate',
    Header: 'Nacimiento',
    headerProps: { style: { minWidth: '14.625rem' } },
    cellProps: {
      className: 'py-2 pe-4'
    },
    Cell: rowData => {
      const { birthDate } = rowData.row.original;
      return parseDate(birthDate);
    }
  },
  {
    accessor: 'phone',
    Header: 'Telefono',
    headerProps: { style: { minWidth: '14.625rem' } },
    cellProps: {
      className: 'py-2 pe-4'
    },
    Cell: rowData => {
      const { phone } = rowData.row.original;
      return phone;
    }
  } 
];

export const columnsUsers = (onDelete) => { 
  const columns = [
    {
      accessor: 'username',
      Header: 'Username',
      headerProps: { className: 'ps-2', style: { height: '46px' } },
      cellProps: {
        className: 'py-2 white-space-nowrap pe-3 pe-xxl-4 ps-2'
      },
      Cell: rowData => {
        const { username } = rowData.row.original;
        return (
          <Flex alignItems="center" className="position-relative py-1">
            <h6 className="mb-0">
              {username}
            </h6>
          </Flex>
        );
      }
    },
    {
      accessor: 'email',
      Header: 'Email',
      headerProps: { style: { minWidth: '14.625rem' } },
      cellProps: {
        className: 'py-2 pe-4'
      },
      Cell: rowData => {
        const { email } = rowData.row.original;
        return email;
      }
    },
    {
      accessor: 'role',
      Header: 'Role',
      headerProps: { style: { minWidth: '14.625rem' } },
      cellProps: {
        className: 'py-2 pe-4'
      },
      Cell: rowData => {
        const { role } = rowData.row.original;
        return role;
      }
    },
    {
      accessor: 'actions',
      Header: 'Actions',
      headerProps: { className: 'text-center', style: { width: '8rem' } },
      cellProps: {
        className: 'py-2 text-center'
      },
      Cell: rowData => {
        const { id } = rowData.row.original;
        return (
          <Button
            size="sm"
            variant="danger"
            onClick={() => onDelete(id)}
          >
            <FontAwesomeIcon icon="trash-alt" />
          </Button>
        );
      }
    }
  ];
  return columns;
};

export const CardLayout = ({ data, isSelectedItem, toggleSelectedItem }) => {
  return (
    <div className="d-flex flex-column gap-3">
      {data.slice(0, 12).map((ticket, index) => (
        <div
          key={index}
          className="bg-white dark__bg-1100 d-md-flex d-xl-inline-block d-xxl-flex align-items-center p-x1 rounded-3 shadow-sm card-view-height w-100"
        >
          <div className="d-flex align-items-start align-items-sm-center">
            <Form.Check
              type="checkbox"
              id="inboxBulkSelect"
              className="fs-0 form-check me-2 me-xxl-3 mb-0"
            >
              <Form.Check.Input
                type="checkbox"
                checked={isSelectedItem(ticket.id)}
                onChange={() => toggleSelectedItem(ticket.id)}
              />
            </Form.Check>
            <Link
              to="/support-desk/contact-details"
              className="d-none d-sm-block"
            >
              {ticket.avatar.img ? (
                <Avatar src={ticket.avatar.img} size="3xl" />
              ) : (
                <Avatar size="3xl" name={ticket.avatar.name} />
              )}
            </Link>
            <div className="ms-1 ms-sm-3">
              <p className="fw-semi-bold mb-3 mb-sm-2">
                <Link to="/support-desk/tickets-preview">{ticket.subject}</Link>
              </p>
              <Row className="align-items-center gx-0 gy-2">
                <Col xs="auto" className="me-2">
                  <h6 className="mb-0">
                    <Link
                      to="/support-desk/contact-details"
                      className="text-800 d-flex align-items-center gap-1"
                    >
                      <FontAwesomeIcon icon="user" transform="shrink-3 up-1" />
                      <span>{ticket.name}</span>
                    </Link>
                  </h6>
                </Col>
                <Col xs="auto" className="lh-1 me-3">
                  <SoftBadge bg={ticket.status.type}>
                    {ticket.status.content}
                  </SoftBadge>
                </Col>
                <Col xs="auto">
                  <h6 className="mb-0 text-500">{ticket.date}</h6>
                </Col>
              </Row>
            </div>
          </div>
          <div className="border-bottom mt-4 mb-x1"></div>
          <div className="d-flex justify-content-between ms-auto">
            <PrioritySelect
              title={ticket.priority.title}
              color={ticket.priority.color}
              data={ticket.priority.data}
              className="ms-md-4 ms-xl-0"
              style={{ width: '7.5rem' }}
            />
            <AgentSelect agent={ticket.agent} style={{ width: '9.375rem' }} />
          </div>
        </div>
      ))}
    </div>
  );
};
export const columnsAlumnosMonths = () => {
/*
"id": 40,
    "alumno_id": 36,
    "mes": "Marzo",
    "monto": "48000.00",
    "status": "pending",
    "id_pagos_tic": "307f71d3-df0a-4cba-a02e-57be2eaf9370",
    "created_at": "2025-03-12T03:18:14.000Z",
    "updated_at": "2025-03-12T03:18:14.000Z",
    "usuario": "tic",
    "metodo": "pagos-tic"
*/
  const columns = [
    {
      accessor: row => `${row.firstName+' '+row.lastName}`,
      Header: 'Alumnos',
      headerProps: { style: { minWidth: '14.625rem' } },
      cellProps: {
        className: 'py-2 pe-4'
      },
      Cell: rowData => {
        const { firstName , lastName } = rowData.row.original;
        return firstName+' '+lastName;
      }
    },
    {
      accessor: 'Mes',
      Header: 'Mes',
      headerProps: { 
        style: { 
            // Opcional: Evita que el texto del header se divida en varias líneas
            whiteSpace: 'nowrap',
        } 
    },
    cellProps: {
        className: 'py-2 pe-4',
        style: {
            // Opcional: Evita que el contenido de la celda se divida en varias líneas
            whiteSpace: 'nowrap',
        }
    },
      Cell: rowData => {
        const { mes } = rowData.row.original;
        return mes;
      }
    },
    {
      accessor: 'Monto',
      Header: 'Monto',
      headerProps: { 
        style: { 
            // Opcional: Evita que el texto del header se divida en varias líneas
            whiteSpace: 'nowrap',
        } 
    },
    cellProps: {
        className: 'py-2 pe-4',
        style: {
            // Opcional: Evita que el contenido de la celda se divida en varias líneas
            whiteSpace: 'nowrap',
        }
    },
      Cell: rowData => {
        const { monto } = rowData.row.original;
        return monto;
      }
    },
    {
      accessor: 'Metodo',
      Header: 'Metodo',
      headerProps: { 
        style: { 
            // Opcional: Evita que el texto del header se divida en varias líneas
            whiteSpace: 'nowrap',
        } 
    },
    cellProps: {
        className: 'py-2 pe-4',
        style: {
            // Opcional: Evita que el contenido de la celda se divida en varias líneas
            whiteSpace: 'nowrap',
        }
    },
    },
    {
      accessor: row => row.created_at,
      Header: 'Emitido',
      headerProps: { 
        style: { 
            // Opcional: Evita que el texto del header se divida en varias líneas
            whiteSpace: 'nowrap',
        } 
    },
    cellProps: {
        className: 'py-2 pe-4',
        style: {
            // Opcional: Evita que el contenido de la celda se divida en varias líneas
            whiteSpace: 'nowrap',
        }
    },
      Cell: rowData => {
        const { created_at } = rowData.row.original;
        return created_at.split('T')[0];
      }
    },
    {
      accessor: row => row.status,
      Header: 'Status',
      headerProps: { 
        style: { 
            // Opcional: Evita que el texto del header se divida en varias líneas
            whiteSpace: 'nowrap',
        } 
    },
    cellProps: {
        className: 'py-2 pe-4',
        style: {
            // Opcional: Evita que el contenido de la celda se divida en varias líneas
            whiteSpace: 'nowrap',
        }
    },
      Cell: rowData => {
            const { status, id } = rowData.row.original;
    const [localStatus, setLocalStatus] = useState(status);
    
    const handleCancel = async () => {
      // Preguntar antes de actualizar
      const confirmUpdate = window.confirm('¿Estás seguro que deseas cancelar este registro?');
      
      if (confirmUpdate) {
        try {
          // Mostrar estado de carga (opcional)
          setLocalStatus('actualizando...');
          
          // Llamar a la API para actualizar
          await updateCuotas(id, 'cancelado');
          
          // Actualizar estado local
          setLocalStatus('cancelado');
        } catch (error) {
          console.error('Error al cancelar:', error);
          // Revertir al estado anterior si hay error
          setLocalStatus(status);
          alert('Ocurrió un error al cancelar');
        }
      }
    }
        return  <><SoftBadge bg={
          localStatus === 'pending' ? 
                      'warning' 
                      : 
          localStatus === 'pagado' ? 'success' : 'danger'}>
        {localStatus == 'pending'? 'pendiente':localStatus}
      </SoftBadge>
      <SoftBadge bg={'danger'}>
   {localStatus !== 'cancelado' && (
          <FiEdit 
            onClick={handleCancel}
            style={{ cursor: 'pointer', color: '#dc3545' }}
            title="Cancelar registro"
          />
        )}
      </SoftBadge>
      </>
      }
    },
    {
      accessor: 'Link',
      Header: 'Link',
      headerProps: { 
        style: { 
            // Opcional: Evita que el texto del header se divida en varias líneas
            whiteSpace: 'nowrap',
        } 
    },
    cellProps: {
        className: 'py-2 pe-4',
        style: {
            // Opcional: Evita que el contenido de la celda se divida en varias líneas
            whiteSpace: 'nowrap',
        }
    },
      Cell: rowData => {
        const { id_pagos_tic } = rowData.row.original;
        return <a
        className='btn'
        href={"https://servicios.paypertic.com/formularios/v2/pagos/" + id_pagos_tic}
        target="_blank"
        rel="noopener noreferrer"
      >
        Link
      </a>
      }
    }
  ];
  //https://servicios.paypertic.com/formularios/v2/pagos/b0f2bb33-7a41-475c-a2de-39fafb9bc2ff
  return columns;
}
export const columnsAlumnosAllMonths = () => {
    const columns = [
      {
        accessor: row => `${row.dni+''+row.firstName+' '+row.lastName}`,
        Header: 'Alumnos',
        headerProps: { 
          style: { 
              whiteSpace: 'nowrap',
          } 
      },
      cellProps: {
          className: 'py-2 pe-4',
          style: {
              whiteSpace: 'nowrap',
          }
      },
        Cell: rowData => {
          const { firstName , lastName  , dni}  = rowData.row.original;
          return <>
            <p>{firstName+' '+lastName}</p>
            <p>{dni}</p>
          </>
        }
      },
      {
        accessor: 'Marzo',
        Header: 'Marzo',
        headerProps: { 
          style: { 
              // Opcional: Evita que el texto del header se divida en varias líneas
              whiteSpace: 'nowrap',
          } 
      },
      cellProps: {
          className: 'py-2 pe-4',
          style: {
              // Opcional: Evita que el contenido de la celda se divida en varias líneas
              whiteSpace: 'nowrap',
          }
      },
        Cell: rowData => {
          const {  montoMarzo , statusMarzo , metodoMarzo , id_pagos_ticMarzo , updatedMarzo } = rowData.row.original;
          return montoMarzo && <>
              <SoftBadge >{statusMarzo}</SoftBadge>
            <p>{metodoMarzo}</p>
            <p>${montoMarzo}</p>
             {updatedMarzo && <p>{updatedMarzo.split("T")[0]}</p>}  
            <a
        className='btn'
        href={"https://servicios.paypertic.com/formularios/v2/pagos/" + id_pagos_ticMarzo}
        target="_blank"
        rel="noopener noreferrer"
      >
        Link
      </a>
            </>;
        }
      },
      {
        accessor: 'Abril',
        Header: 'Abril',
        headerProps: { 
          style: { 
              // Opcional: Evita que el texto del header se divida en varias líneas
              whiteSpace: 'nowrap',
          } 
      },
      cellProps: {
          className: 'py-2 pe-4',
          style: {
              // Opcional: Evita que el contenido de la celda se divida en varias líneas
              whiteSpace: 'nowrap',
          }
      },
        Cell: rowData => {
          const {  montoAbril , statusAbril , metodoAbril , id_pagos_ticAbril, updatedAbril} = rowData.row.original;
          return montoAbril && <>
              <SoftBadge >{statusAbril}</SoftBadge>
                        <p>{metodoAbril}</p>
                        <p>${montoAbril}</p>
                         {updatedAbril && <p>{updatedAbril.split("T")[0]}</p>}  
                        <a
                        className='btn'
                        href={"https://servicios.paypertic.com/formularios/v2/pagos/" + id_pagos_ticAbril}
                        target="_blank"
                        rel="noopener noreferrer"
                        >
                        Link
                        </a>
            </>;
        }
      },
      {
        accessor: 'Mayo',
        Header: 'Mayo',
        headerProps: { 
          style: { 
              // Opcional: Evita que el texto del header se divida en varias líneas
              whiteSpace: 'nowrap',
          } 
      },
      cellProps: {
          className: 'py-2 pe-4',
          style: {
              // Opcional: Evita que el contenido de la celda se divida en varias líneas
              whiteSpace: 'nowrap',
          }
      },
        Cell: rowData => {
          const {  montoMayo , statusMayo , metodoMayo , id_pagos_ticMayo, updatedMayo } = rowData.row.original;
          return montoMayo && <>
              <SoftBadge >{statusMayo}</SoftBadge>
            <p>{metodoMayo}</p>
            <p>${montoMayo}</p>
             {updatedMayo && <p>{updatedMayo.split("T")[0]}</p>}  
            <a
              className='btn'
              href={"https://servicios.paypertic.com/formularios/v2/pagos/" + id_pagos_ticMayo}
              target="_blank"
              rel="noopener noreferrer"
            >
            Link
          </a>
            </>;
        }
      },
      {
        accessor: 'Junio',
        Header: 'Junio',
        headerProps: { 
          style: { 
              // Opcional: Evita que el texto del header se divida en varias líneas
              whiteSpace: 'nowrap',
          } 
      },
      cellProps: {
          className: 'py-2 pe-4',
          style: {
              // Opcional: Evita que el contenido de la celda se divida en varias líneas
              whiteSpace: 'nowrap',
          }
      },
        Cell: rowData => {
          const {  montoJunio , statusJunio , metodoJunio , id_pagos_ticJunio, updatedJunio} = rowData.row.original;
          return montoJunio && <>
              <SoftBadge >{statusJunio}</SoftBadge>
            <p>{metodoJunio}</p>
            <p>${montoJunio}</p>
             {updatedJunio && <p>{updatedJunio.split("T")[0]}</p>}  
            <a
        className='btn'
        href={"https://servicios.paypertic.com/formularios/v2/pagos/" + id_pagos_ticJunio}
        target="_blank"
        rel="noopener noreferrer"
      >
        Link
      </a>
            </>;
        }
      },
      {
        accessor: 'Julio',
        Header: 'Julio',
        headerProps: { 
          style: { 
              // Opcional: Evita que el texto del header se divida en varias líneas
              whiteSpace: 'nowrap',
          } 
      },
      cellProps: {
          className: 'py-2 pe-4',
          style: {
              // Opcional: Evita que el contenido de la celda se divida en varias líneas
              whiteSpace: 'nowrap',
          }
      },
        Cell: rowData => {
          const {  montoJulio , statusJulio , metodoJulio , id_pagos_ticJulio, updatedJulio } = rowData.row.original;
          return <> {montoJulio && (          <><SoftBadge >{statusJulio}</SoftBadge>
            <p>{metodoJulio}</p>
            <p>${montoJulio}</p>
             {updatedJulio && <p>{updatedJulio.split("T")[0]}</p>}  
            <a
        className='btn'
        href={"https://servicios.paypertic.com/formularios/v2/pagos/" + id_pagos_ticJulio}
        target="_blank"
        rel="noopener noreferrer"
      >
        Link
      </a></>)}
             
            </>;
        }
      },
      {
        accessor: 'Agosto',
        Header: 'Agosto',
        headerProps: { 
          style: { 
              // Opcional: Evita que el texto del header se divida en varias líneas
              whiteSpace: 'nowrap',
          } 
      },
      cellProps: {
          className: 'py-2 pe-4',
          style: {
              // Opcional: Evita que el contenido de la celda se divida en varias líneas
              whiteSpace: 'nowrap',
          }
      },
        Cell: rowData => {
          const {  montoAgosto , statusAgosto , metodoAgosto , id_pagos_ticAgosto, updatedAgosto } = rowData.row.original;
          return montoAgosto && <>
              <SoftBadge >{statusAgosto}</SoftBadge>
            <p>{metodoAgosto}</p>
            <p>${montoAgosto}</p>
             {updatedAgosto && <p>{updatedAgosto.split("T")[0]}</p>}  
            <a
        className='btn'
        href={"https://servicios.paypertic.com/formularios/v2/pagos/" + id_pagos_ticAgosto}
        target="_blank"
        rel="noopener noreferrer"
      >
        Link
      </a>
            </>;
        }
      },
      {
        accessor: 'Septiembre',
        Header: 'Septiembre',
        headerProps: { 
          style: { 
              // Opcional: Evita que el texto del header se divida en varias líneas
              whiteSpace: 'nowrap',
          } 
      },
      cellProps: {
          className: 'py-2 pe-4',
          style: {
              // Opcional: Evita que el contenido de la celda se divida en varias líneas
              whiteSpace: 'nowrap',
          }
      },
        Cell: rowData => {
          const {  montoSeptiembre , statusSeptiembre , metodoSeptiembre , id_pagos_ticSeptiembre, updatedSeptiembre } = rowData.row.original;
          return montoSeptiembre && <>
              <SoftBadge >{statusSeptiembre}</SoftBadge>
            <p>{metodoSeptiembre}</p>
            <p>${montoSeptiembre}</p>
             {updatedSeptiembre && <p>{updatedSeptiembre.split("T")[0]}</p>}  
            <a
        className='btn'
        href={"https://servicios.paypertic.com/formularios/v2/pagos/" + id_pagos_ticSeptiembre}
        target="_blank"
        rel="noopener noreferrer"
      >
        Link
      </a>
            </>;
        }
      },
      {
        accessor: 'Octubre',
        Header: 'Octubre',
        headerProps: { 
          style: { 
              // Opcional: Evita que el texto del header se divida en varias líneas
              whiteSpace: 'nowrap',
          } 
      },
      cellProps: {
          className: 'py-2 pe-4',
          style: {
              // Opcional: Evita que el contenido de la celda se divida en varias líneas
              whiteSpace: 'nowrap',
          }
      },
        Cell: rowData => {
          const {  montoOctubre , statusOctubre , metodoOctubre, id_pagos_ticOctubre, updatedOctubre } = rowData.row.original;
          return montoOctubre && <>
              <SoftBadge >{statusOctubre}</SoftBadge>
            <p>{metodoOctubre}</p>
            <p>${montoOctubre}</p>
             {updatedOctubre && <p>{updatedOctubre.split("T")[0]}</p>}  
            <a
        className='btn'
        href={"https://servicios.paypertic.com/formularios/v2/pagos/" + id_pagos_ticOctubre}
        target="_blank"
        rel="noopener noreferrer"
      >
        Link
      </a>
            </>;
        }
      },
      {
        accessor: 'Noviembre',
        Header: 'Noviembre',
        headerProps: { 
          style: { 
              // Opcional: Evita que el texto del header se divida en varias líneas
              whiteSpace: 'nowrap',
          } 
      },
      cellProps: {
          className: 'py-2 pe-4',
          style: {
              // Opcional: Evita que el contenido de la celda se divida en varias líneas
              whiteSpace: 'nowrap',
          }
      },
        Cell: rowData => {
          const {  montoNoviembre , statusNoviembre , metodoNoviembre , id_pagos_ticNoviembre , updatedNoviembre} = rowData.row.original;
          return montoNoviembre  &&  <>
              <SoftBadge >{statusNoviembre}</SoftBadge>
            <p>{metodoNoviembre}</p>
            <p>${montoNoviembre}</p>
             {updatedNoviembre && <p>{updatedNoviembre.split("T")[0]}</p>}  
            <a
        className='btn'
        href={"https://servicios.paypertic.com/formularios/v2/pagos/" + id_pagos_ticNoviembre}
        target="_blank"
        rel="noopener noreferrer"
      >
        Link
      </a>
            </>;
        }
      },
      {
        accessor: 'Diciembre',
        Header: 'Diciembre',
        headerProps: { 
          style: { 
              // Opcional: Evita que el texto del header se divida en varias líneas
              whiteSpace: 'nowrap',
          } 
      },
      cellProps: {
          className: 'py-2 pe-4',
          style: {
              // Opcional: Evita que el contenido de la celda se divida en varias líneas
              whiteSpace: 'nowrap',
          }
      },
        Cell: rowData => {
          const {  montoDiciembre , statusDiciembre , metodoDiciembre , id_pagos_ticDiciembre , updatedDiciembre } = rowData.row.original;
          return montoDiciembre && <>
              <SoftBadge >{statusDiciembre}</SoftBadge>
            <p>{metodoDiciembre}</p>
            <p>${montoDiciembre}</p>
            {updatedDiciembre && <p>{updatedDiciembre.split("T")[0]}</p>}  
            <a
        className='btn'
        href={"https://servicios.paypertic.com/formularios/v2/pagos/" + id_pagos_ticDiciembre}
        target="_blank"
        rel="noopener noreferrer"
      >
        Link
      </a>
            </>;
        }
      }
    ];
    //https://servicios.paypertic.com/formularios/v2/pagos/b0f2bb33-7a41-475c-a2de-39fafb9bc2ff
    return columns;
  }

CardLayout.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  isSelectedItem: PropTypes.func,
  toggleSelectedItem: PropTypes.func
};
/*

Tareas para el pago de cuotas
-	Agregar el valor de la cuota a cada nivel.
-	Agregar un botón para identificar a alumnos hermanos. En este caso cada alumno lleva un descuento del 7% en las cuotas de marzo a noviembre. El derecho de examen que se cobrará en diciembre y la inscripción no llevan este descuento
-	Agregar un botón para identificar a alumnos hijos del personal. En este caso cada alumno lleva un descuento del 50% en todas las cuotas, derecho de examen e inscripción. 
-	Agregar un recargo del 10% a todas las cuotas si el pago se realiza después del 15 de cada mes. En este caso también pierde el descuento por hermano.
-	Agregar un recargo del 5% a todas las cuotas que paguen por mes vencido.
-	Agregar un medio para que el padre que quiera pagar de manera presencial con todos los medios de pago lo pueda hacer y que el secretario pueda registrar esto en el sistema. 
-	Agregar una forma de descargar una planilla por día con los pagos que recibió cada usuario y el medio de pago. 
-	Por cuestiones de tiempo y administrativas, en el mes de marzo no se hará ningún recargo, se dejará el mismo monto y descuentos todo el mes, a partir de abril sí se implementarán los recargos. 
-	En la pantalla de inicio, donde dice alumnos 400, que esté el número real de alumnos.
-	Que el sistema envíe mail de recordatorios con el cupón de pago a los padres al comienzo del mes y antes del 15 de cada mes.

*/
export const columnsCuotas2025 =  ( cursos ) => {
  const columns = [
    {
      accessor: row => `${row.firstName} ${row.lastName}`,
      Header: 'Alumno',
      headerProps: { style: { Width: '200px' } },
      cellProps: {
        className: 'py-2 white-space-nowrap pe-3 pe-xxl-4 ps-2'
      },
      Cell: rowData => {
        const { firstName , lastName , id } = rowData.row.original;
        return (
          <Flex alignItems="center" className="position-relative py-1">
            <h6 className="mb-0">
              <Link
                to={"/support-desk/contact-details/"+id}
                className="stretched-link text-900"
              >
                {firstName+" "+lastName}
              </Link>
            </h6>
          </Flex>
        );
      }
    }, 
    {
      accessor: row => `${row.curso_id}`,
      Header: 'Curso',
      headerProps: { style: { minWidth: '14.625rem' } },
      cellProps: {
        className: 'py-2 pe-4'
      },
      Cell: rowData => {
        const { curso_id } = rowData.row.original;
        const { nivel } = rowData.row.original;
        const dataCurso = cursos.find(curso => curso.id === curso_id);
        console.log(curso_id);
        return (
          <div value={dataCurso ? dataCurso.nivel : nivel}>
              {dataCurso ? dataCurso.nivel : nivel}
          </div>
        );
      }
    },
    {
      accessor: row => `${row.curso_id}`,
      Header: 'Precio Mes',
      headerProps: { style: { minWidth: '14.625rem' } },
      cellProps: {
        className: 'py-2 pe-4'
      },
      Cell: rowData => {
        const { price_month } = rowData.row.original;
        return (
          <div>
              {'$ '+price_month}
          </div>
        );
      }
    },
    {
      accessor: 'Cuota',
      Header: 'Cuota',
      cellProps: {
        className: 'fs-0 pe-4'
      },
      Cell: rowData => {
        const { id , type_cuota } = rowData.row.original;
        const [ localTypeCuota , setLocalTypeCuota ] = useState(type_cuota);
        const selectStyle = {
          backgroundColor:
              localTypeCuota === "type1" ? "#ffcccc" : // Rojo claro
              localTypeCuota === "type2" ? "#ccffcc" : // Verde claro
              localTypeCuota === "type3" ? "#ccccff" : // Azul claro
              "#ffffff", // Blanco por defecto
          padding: "5px",
          borderRadius: "4px",
          border: "1px solid #ccc",
      };
        const toShow = (type) =>{
          if(type==='type1'){
            return "Alumno 0%"
          }
          if(type==='type2'){
            return "Alumno Hermano 7%"
          }
          if(type==='type3'){
            return "Hijo De Profesor 50%"
          }
        }
        return (
          <>
            <select onChange={(e) => {
              setLocalTypeCuota(e.target.value);
              updateTypeCuota(id,'2025',e.target.value);
              }
            } 
                    style={selectStyle}
            >
              <option>{toShow(localTypeCuota)}</option>
              <option value={'type1'}>{'Alumno 0%'}</option>
              <option value={'type2'}>{'Alumno Hermano 7%'}</option>
              <option value={'type3'}>{'Hijo de profesor 50%'}</option>
            </select>
          </>
        );
      }
    }
  ];
  
  return columns;
}